import React, { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton } from "../../../../containers/UI/Modal/BaseModal";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import InfoRow from "../../../configuration/Rows/InfoRow/InfoRow";
import CheckboxRow from "../../../configuration/shared/CheckboxRow/CheckboxRow";
import classes from "./GenerateLicense.css"
import axios from "../../../../axios";


class GenerateLicense extends Component {

  state = {
    gatewayOptions: [],
    gateways: [],
    chosenGateway: "",
    validity: "50years",
    forwarderCount: "0",
    enableInternalRadio: true,
    loraDeviceLimit: "250",
    whiteLabelVendor: "allorado",
    licenseType: "",
    protocols: { BACnet: true, KNX: false, Modbus: false, MQTT: false }
  }

  validityOptions = [
    { value: "1months",   label: "1 month (demo)"},
    { value: "3months",   label: "3 months (demo)"},
    { value: "1years",    label: "1 year (demo)"},
    { value: "30years",   label: "30 years"},
    { value: "50years",   label: "50 years (default)"}]
  radioOptions = [
    { value: "enable", label: "Enable internal radio"},
    { value: "disable", label: "Disable internal radio"}]
  deviceOptions = [
    { value: "10", label: "10 devices (Starter)"},
    { value: "20", label: "20 devices (Starter Giga)"},
    { value: "50", label: "50 devices"},
    { value: "100", label: "100 devices (Pro)"},
    { value: "250", label: "250 devices (Enterprise)"},
    { value: "350", label: "350 devices"},
    { value: "450", label: "450 devices"},
    { value: "550", label: "550 devices"},
    { value: "650", label: "650 devices"},
    { value: "750", label: "750 devices"},
    { value: "850", label: "850 devices"},
    { value: "950", label: "950 devices"},
    { value: "1050", label: "1.050 devices"},
    { value: "1150", label: "1.150 devices"},
    { value: "2500", label: "2.500 devices"},
    { value: "5000", label: "5.000 devices"},
    { value: "10000", label: "10.000 devices"}]
  whiteLabelOptions = [
    { value: "allorado", label: "Brand as Allorado"},
    { value: "mcs", label: "MCS white-label"},
  ]
  customerWhiteLabel = { 
    "64206ebb576ca002e929178c": "mcs"
  }
  formatOptions = [
    { value: "1.3", label: "Software 1.3 and later"},
    { value: "1.9", label: "Software 1.9 and later"},
  ]

  componentDidMount() {
    axios.get("/fleet/all").then(response => {
      if (response.data) {

        // Keep track of models, for functionality restriction
        let gateways = {}

        // Construct
        response.data.forEach(gateway => {
          gateways[gateway._id] = gateway
        })

        this.setState({ 
          gatewayOptions: response.data.map(item => { return { label: item.serialNumber + " - " + item.trivialName, value: item._id, customer: item.customer }}), 
          gateways: gateways,
        })
      }
    })
  }


  generateLicense = () => {

    if (this.state.chosenGateway === "") {
      alert("Please select a serial number.")
      return
    }

    if (this.state.licenseType === "") {
      alert("Please select a license type.")
      return
    }

    // Check if it has a valid CPU uuid
    let gateway = this.state.gateways[this.state.chosenGateway] ?? {}

    // Check for empty CPU UUID
    if (!gateway.cpuUUID || (gateway.cpuUUID.length !== 32 && gateway.cpuUUID.length !== 16)) {
      alert("This gateway does not have a valid CPU UUID. \nPlease fill in a valid CPU UUID first.")
      return
    }

    // Validate forwarder count
    if (this.state.licenseType === "master" || this.state.licenseType === "evolution") {
      if (!this.state.forwarderCount || isNaN(this.state.forwarderCount)) {
        alert("Please enter a valid number of allowed forwarders.")
        return
      }
    }

    // Determine format version
    let formatVersion = this.state.formatVersion

    // In case of TPM licensing, we automatically switch to 1.9
    if ("tpmPubKey" in gateway) {
      if (gateway.tpmPubKey.length > 0) {
        formatVersion = "1.9"
      }
    }

    // Create to be generated license
    var license = {
      // Backend will retrieve details and populate
      // UUID, TPM public key and verification method
      gatewayID: this.state.chosenGateway,
      formatVersion: parseFloat(formatVersion),
      // Backend will assign UUIDv4 and start / end
      duration: this.state.validity,
      // Product-specific
      product: this.state.licenseType,
      productSpecific: {}
    }

    // Add protocol-specific fields
    switch (this.state.licenseType) {
      case "master":
        license.whiteLabel = this.state.whiteLabelVendor
        license.productSpecific = {
          internalRadio: this.state.enableInternalRadio,
          forwarders: parseInt(this.state.forwarderCount),
          loraDevices: parseInt(this.state.loraDeviceLimit),
          protocols: Object.keys(this.state.protocols).filter(v => this.state.protocols[v] === true)
        }
        break

      case "slave":
      case "knx-iot-router":
      case "knx-lora-gateway":
      case "knx-lora-forwarder":

        license.whiteLabel = this.state.whiteLabelVendor
        break

      case "evolution":

        license.productSpecific = {
          forwarders: this.state.forwarderCount,
          loraDevices: this.state.loraDeviceLimit,
        }
        break

      default: break
    }

    // Sync to the backend
    axios.post("/license/generate", license);
    // Close the modal view
    this.props.closeModal()
  }


  render() {

    // Determine mechanism
    let tpmLicensing = false
    let gateway = this.state.gateways[this.state.chosenGateway]
    if (gateway) {
      if ("tpmPubKey" in gateway) {
        if (gateway.tpmPubKey.length > 0) {
          tpmLicensing = true
        }
      }
    }

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title="Generate license"
      >
        <SelectRow
          title="Gateway"
          firstRow
          ultrawide
          increasedPadding
          value={this.state.chosenGateway}
          onChange={(newValue) => {
            this.setState({ 
              licenseType: "",
              chosenGateway: newValue.value,
              formatVersion: this.proposeFormatVersion(newValue.value),
              whiteLabelVendor: (newValue.customer in this.customerWhiteLabel) ? this.customerWhiteLabel[newValue.customer] : "allorado", 
            })
          }}
          options={this.state.gatewayOptions}/>
        <SelectRow
          title="License format"
          ultrawide increasedPadding
          show={this.state.chosenGateway !== "" && tpmLicensing === false}
          value={this.state.formatVersion}
          onChange={(newValue) => this.setState({ formatVersion: newValue.value })}
          options={this.formatOptions}/>
        <InfoRow
          title="License mechanism"
          ultrawide
          show={this.state.chosenGateway !== ""}
          body={tpmLicensing ? "TPM-based license 🔒✅" : "UUID-based license  🔒⚠️"}/>

        <hr style={{ border: "0.7px solid #FF6315", margin: "10px 0 10px 0" }}/>

        <SelectRow
          title="License type"
          ultrawide increasedPadding firstRow
          value={this.state.licenseType}
          onChange={(newValue) => this.setState({ licenseType: newValue.value })}
          options={this.licenseTypeOptions()}/>
        <SelectRow
          title="Duration"
          ultrawide increasedPadding
          show={this.state.licenseType !== ""}
          value={this.state.validity ?? ""}
          onChange={(newValue) => this.setState({ validity: newValue.value })}
          options={this.validityOptions}/>

        <SelectRow
          title="White-label vendor"
          ultrawide increasedPadding
          show={this.state.licenseType !== "" && this.state.licenseType !== "evolution"}
          value={this.state.whiteLabelVendor}
          onChange={(newValue) => this.setState({ whiteLabelVendor: newValue.value })}
          options={this.whiteLabelOptions}/>

        <hr style={{ border: "0.7px solid #FF6315", margin: "10px 0 10px 0", display: (this.state.licenseType !== "") ? "block" : "none" }}/>

        <SelectRow
          title="Internal radio"
          ultrawide increasedPadding firstRow
          show={this.state.licenseType === "master"}
          value={(this.state.enableInternalRadio === true) ? "enable" : "disable"}
          onChange={(newValue) => {
            let enable = (newValue.value === "enable")
            let forwarder = (enable === false && this.state.forwarderCount === "0") ? "1" : this.state.forwarderCount
            this.setState({ enableInternalRadio: enable, forwarderCount: forwarder })
          }}
          options={this.radioOptions}/>
        <InputRow
          enabled ultrawide
          show={this.state.licenseType === "master" || this.state.licenseType === "evolution" }
          title="External forwarders"
          placeholder="Enter a number"
          value={this.state.forwarderCount }
          onChange={(event) => this.setState({ forwarderCount: event.target.value })}/>
        <SelectRow
          title="LoRa devices"
          ultrawide increasedPadding
          show={(this.state.licenseType === "master" || this.state.licenseType === "evolution")}
          value={this.state.loraDeviceLimit}
          onChange={(newValue) => this.setState({ loraDeviceLimit: newValue.value })}
          options={this.deviceOptions}/>
        <CheckboxRow
          title="Protocol conversion"
          options={this.state.protocols}
          show={this.state.licenseType === "master"}
          optionChanged={(option, checked) => {
            let protocols = {...this.state.protocols}
            protocols[option] = checked
            this.setState({ protocols })
          }}/>

        <ModalActions>
          <CancelButton onClick={this.props.closeModal}/>
          <SaveButton onClick={this.generateLicense}>Generate</SaveButton>
        </ModalActions>
      </BaseModal>
    );
  }

  // MARK: - Helpers

  licenseTypeOptions = () => {

    if (this.state.chosenGateway) {
      
      // Define base options
      let options = [
        { value: "master", label: "Concentrator gateway"},
        { value: "slave", label: "Forwarder gateway"},
      ]

      // Allow different licenses based on model
      let gateway = this.state.gateways[this.state.chosenGateway]
      let model = gateway.model
      let tpmLicensing = false

      if ("tpmPubKey" in gateway) {
        if (gateway.tpmPubKey.length > 0) {
          tpmLicensing = true
        }
      }

      // Evolution
      if (model === "evolution") {
        return [{ value: "evolution", label: "Futurasmus Evolution" }]
      }
      
      // CM4-based products
      if ((model.startsWith("r") || model.startsWith("cm4-board")) && tpmLicensing === true) {
        options.push(
          { value: "knx-iot-router", label: "KNX IoT router"},
          { value: "knx-lora-gateway", label: "KNX LoRa gateway"},
          { value: "knx-lora-forwarder", label: "KNX LoRa forwarder"},
        )
      }
      return options
    } else {
      return []
    }
  }

  proposeFormatVersion = (gatewayID) => {

    // Retrieve gateway
    let gateway = this.state.gateways[gatewayID]

    if (gateway) {
      if (gateway.versionNumber) {
        if (gateway.versionNumber.length > 0) {

          // Parse and compare
          let parts = gateway.versionNumber.split(".")
          let version = parseFloat(parts[0] + "." + (parts[1] || "0"))

          if (version >= 1.9) {
            return "1.9"
          }
        }
      }
    }

    return "1.3"
  }
}

export default GenerateLicense
